<!-- @format -->
<template>
	<div class="pcp-out-systems">
		<div v-for="(item, index) in globalStore.subSystems" :key="item.id" class="pcp-systems-name">
			<span :class="{ 'active-name': activeIndex === index }" @click="navigateFn(item, index)">{{ item.name }}</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { watch, ref, onMounted } from 'vue';
	import { param2Obj } from '@power/utils';
	import { getMenu, useGlobalStoreWithOut, getEnvUrlByUrl } from '@power/runtime-vue3';
	import { useRouterStoreWithOut } from '@/store/modules/router';
	import { useMenuStoreWithOut } from '@/store/modules/menu';
	const globalStore = useGlobalStoreWithOut();
	const menuStore = useMenuStoreWithOut();
	const router = useRouter();
	const activeIndex = ref(0);
	// 默认系统别名
	const alias = 'powercommon2';
	// 默认首页id
	const systemId = ref('');
	const currHomePage = ref('');
	// 点击上方导航栏切换;
	const navigateFn = async (item, index) => {
		currHomePage.value = item.homePage;
		activeIndex.value = index;
		systemId.value = item.id;
		menuStore.setAddAlias(true);
		const url = getEnvUrlByUrl(`power-api/base/user/context/getMenu?systemId=${item.id}`);
		await menuStore.setUrl(url);
		await getMenuInfo(item);
	};
	// 菜单接口
	const getMenuInfo = async (data) => {
		if (!globalStore.token) {
			return;
		}
		let params = {};
		if (menuStore.url) {
			params = {
				url: menuStore.url,
			};
		} else if (globalStore.curSystem?.id) {
			params = {
				systemId: globalStore.curSystem?.id,
			};
		} else {
			return;
		}
		const res = await getMenu(params);
		filterEditMenus(res, data);
	};
	// 侧边栏及头部隐藏
	const filterEditMenus = async (res, data) => {
		const hide = 'hidePcLayoutHeader=1&hidePcLayoutMenu=1';

		res.forEach((item) => {
			if (item.defaultUrl.includes('?') && !item.defaultUrl.includes(hide)) {
				item.defaultUrl = `${item.defaultUrl}&${hide}`;
			}
			if (item.defaultUrl.length > 0 && !item.defaultUrl.includes(hide)) {
				item.defaultUrl = `${item.defaultUrl}?${hide}`;
			}
			// 转为内部系统
			if (item.sysType === 'self') {
				item.sysType = 'inner';
			}
		});

		// 参数修改后调用菜单整理;
		menuStore.setMenusByRes(res);
		// 更新路由菜单
		const routerStore = useRouterStoreWithOut();
		const generatorResult = await routerStore.generatorDynamicRouter(menuStore.menus);
		menuStore.setDisplayMenus(generatorResult.menus);

		activeMenu(data);
	};
	// 跳转配置的homepage首页
	const activeMenu = (data) => {
		let homePage = getEnvUrlByUrl(data.homePage);
		console.log('homePage', homePage);

		homePage = homePage.replaceAll('$token$', window.pData?.globalStore?.token || '');

		// 新开窗口外部打开
		if ('newWindow' === data.openWay) {
			window.open(homePage);
			return;
		}

		// 含有以下子系统地址改为内部打开且头部保留
		const routerStore = useRouterStoreWithOut();

		if (data.homePage.includes('linkurl')) {
			const tmpUrl = homePage;
			const obj = param2Obj(tmpUrl);
			routerStore.setLinkUrl(obj.linkurl);
		} else if (data.homePage.includes('paas/#/powerpaas')) {
			routerStore.setLinkUrl(homePage);
		} else {
			// 重新赋值为空
			routerStore.setLinkUrl('');
		}

		// 正常的菜单
		const hide = 'hidePcLayoutHeader=1&hidePcLayoutMenu=1';
		// 解码做数据处理
		homePage = decodeURIComponent(homePage);
		if (homePage.includes('?') && !homePage.includes(hide)) {
			homePage = `${homePage}&${hide}`;
		}
		if (!homePage.includes(hide)) {
			homePage = `${homePage}?${hide}`;
		}
		// 编码对应菜单
		homePage = encodeURIComponent(homePage);
		// 系统别名
		homePage = `/${alias}/inner/${homePage}`;
		router.push(homePage);
	};
	// 默认点击一次
	onMounted(async () => {
		await navigateFn(globalStore.subSystems[0], 0);
	});
	watch(
		() => systemId.value,
		(newVal, oldVal) => {
			if (newVal && newVal !== oldVal) {
				try {
					if (currHomePage.value.includes('paas/#/powerpaas')) {
						if (window.frames['0'] && window.frames['0'].location.href) {
							const url = getEnvUrlByUrl(currHomePage.value);
							window.frames['0'].location.href = url;
							window.frames['0'].location.reload();
						}
					}
				} catch (e) {
					console.log('error', e);
				}
			}
		},
		{ deep: true, immediate: true },
	);
</script>

<style lang="scss" scoped>
	@import '../../assets/styles/themes/pcp-header.scss';

	.pcp-out-systems {
		display: flex;
		margin-left: 120px;
		width: 800px;
		white-space: nowrap;
		overflow-x: auto;

		&::-webkit-scrollbar {
			width: 0px;
			height: 0px;
		}

		.pcp-systems-name {
			margin-left: 20px;

			:hover {
				color: var(--theme-header-hover-selected-name-color);
				cursor: pointer;
			}

			.active-name {
				color: var(--theme-header-hover-selected-name-color);
				cursor: pointer;
			}
		}
	}
</style>
